import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { EmailTemplate } from "types";
import { api } from "../../../api/api";
import { useSeller } from "../../../hooks/useAccount";
import { useVisibility } from "../../../hooks/useVisibility";
import { PreviewMessageTemplateDrawer } from "./PreviewMessageTemplateDrawer";

interface PreviewMessageTemplateProps {
    isOpen: boolean;
    payload: {
        template: EmailTemplate;
        experience?: string;
        giftOffer?: string;
        ware?: string;
    };
    onClose: () => void;
}

export const PreviewMessageTemplate = ({ isOpen, payload, onClose }: PreviewMessageTemplateProps) => {
    const seller = useSeller();
    const [isPreviewVisible, { toggle: togglePreview }] = useVisibility(false);

    const { mutateAsync: previewMessage, data: previewContent } = useMutation(
        async () => {
            const { data } = await api.post<string>(`/sellers/${seller.id}/messages/preview`, payload);
            return data;
        },
        { onSuccess: () => togglePreview() },
    );

    useEffect(() => {
        if (isOpen) {
            previewMessage();
        }
    }, [isOpen, previewMessage]);

    const handleClose = () => {
        togglePreview();
        onClose();
    };

    return (
        <PreviewMessageTemplateDrawer isOpen={isPreviewVisible} onClose={handleClose}>
            {previewContent ? (
                <iframe sandbox="allow-same-origin" srcDoc={previewContent} className="h-full w-full" />
            ) : null}
        </PreviewMessageTemplateDrawer>
    );
};
